<template>
  <div class="mm-page-main">
    <div v-if="!isdetail">
      <div class="page-header">
        <div class="page-title">門市現金記錄</div>

      </div>
      <search :form="form" @submit="getcashlogs"></search>
      <div style="height: 20px;">

      </div>
      <div v-if="stores.length>0" class="mm-tabs">
        <div class="mm-tabsulbox">
          <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
          <ul :style="transform" class="mm-tabs-card">
            <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
          </ul>
          <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="mm-tabs-content">

          <div class="pagetablebox">
            <el-table v-loading="loading" empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column prop="name" label="貨幣" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">貨幣</div>
                  <div style="display: flex; align-items: flex-end; ">
                    <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                    <div style="margin-left: 10px;">{{scope.row.name}}</div>
                    <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="addtime" label="日期" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">日期</div>
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="income" label="收入" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">收入</div>
                  <span v-if="scope.row.income>0" class="textblue">{{tomoney(scope.row.income)}}</span>
                </template>
              </el-table-column>
              </el-table-column>
              <el-table-column prop="pay" label="支出" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">支出</div>
                  <span v-if="scope.row.pay>0" class="textred">{{tomoney(scope.row.pay)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="surplus" v-if="customer_id==0" label="結餘" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">結餘</div>
                  <div>{{tomoney(scope.row.surplus)}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="customer_surplus"  v-if="customer_id>0" label="結餘" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">結餘</div>
                  <div>{{tomoney(scope.row.customer_surplus)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="關聯交易單號" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">關聯交易單號</div>
                  <el-link type="primary" v-if="scope.row.buytype == 0" @click="buydetails(scope.row.business_id)">B{{scope.row.businessnum}}</el-link>
                  <el-link type="primary" v-else-if="scope.row.buytype == 1" @click="selldetails(scope.row.business_id)">S{{scope.row.businessnum}}</el-link>
                </template>
              </el-table-column>
              <el-table-column label="關聯訂單號" align="center" >
                <template slot-scope="scope">
                  <div class="phonecel">關聯訂單號</div>
                  <el-link @click="orderdetails(scope.row.order_id)" type="primary">
                    <span v-if="scope.row.ordertype == 0">{{scope.row.store_short}}-C{{scope.row.ordernum}}</span>
                    <span v-else-if="scope.row.ordertype == 1">{{scope.row.store_short}}-R{{scope.row.ordernum}}</span>
                    <span v-else-if="scope.row.ordertype == 2">{{scope.row.store_short}}-I{{scope.row.ordernum}}</span>
                  </el-link>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="page-bottom">
            <div>
            </div>
            <div>
              <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
              </el-pagination>
            </div>
            <div>
              Total: {{pager.p_count}} 條記錄
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isdetail">
      <buybuinessdetails v-if="buinesstype==0" :visible.sync="isdetail" @refresh="getcashlogs" :id="buineessid"></buybuinessdetails>
      <sellbuinessdetails v-if="buinesstype==1" :visible.sync="isdetail" @refresh="getcashlogs" :id="buineessid"></sellbuinessdetails>
    </div>

  </div>
</template>

<script>
import search from "./components/Search.vue";
import buybuinessdetails from "@/components/BuyBusinessDetails.vue";
import sellbuinessdetails from "@/components/SellBusinessDetails.vue";
export default {
  components: {
    search,
    buybuinessdetails,
    sellbuinessdetails
  },
  props:{
    customer_id:{
      type:Number,
      default:0,
    }
  },
  data () {
    return {
      buineessid: 0,
      isdetail: false,
      buinesstype: 0,
      loading: true,
      is_init: true,
      store_id: 0,
      stores: [],
      transform: '',
      transformnum: 0,
      form: {
        currency: [],
        record_type: "-1",
        currency_id: "-1",
        starttime: '',
        endtime: '',
        sortname:'addtime',
        orderby:'DESC',
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: []
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    edit (row) {
      this.$router.push({
        name: '/EditCashAccount',
        path: '/EditCashAccount',
        params: {
          row: row
        }
      })
    },
    buydetails (id) {
      this.buineessid = id;
      this.buinesstype = 0;
      this.isdetail = true;
      // this.$router.push({
      //   name: '/BuyBusinessDetails',
      //   path: '/BuyBusinessDetails',
      //   params: {
      //     id: id
      //   }
      // })
    },
    selldetails (id) {
      this.buineessid = id;
      this.buinesstype = 1;
      this.isdetail = true;
      // this.$router.push({
      //   name: '/SellBusinessDetails',
      //   path: '/SellBusinessDetails',
      //   params: {
      //     id: id
      //   }
      // })
    },
    orderdetails (id) {
      this.$router.push({
        name: '/OrderDetails',
        path: '/OrderDetails',
        query: {
          id: id
        }
      })
    },
    async getCurrency () {
      // 获取货币
      let store_id = this.store_id;
      await this.post('/api/funds/getcurrency', { store_id: store_id, 'type0': 1 })
        .then(response => {
          let currency = this.form.currency = response;
          // 默认 设置
          if (this.is_init) {
            currency.some(item => {
              if (item.short_name == 'HKD') {
                this.form.currency_id = item.currency_id;
              }
            })
            this.is_init = false;
          }

        }).catch(error => {
          console.log(error);
        })
    },
    getcashlogs () {
      this.data = [];
      this.loading = true;
      let form = this.form;
      this.post('/api/funds/getcashlogs', {
        customer_id: this.customer_id,
        store_id: this.store_id,
        page: this.page,
        pagesize: this.pagesize,
        currency_id: form.currency_id,
        record_type: form.record_type,
        starttime: form.starttime,
        endtime: form.endtime,
        startamount: form.startamount,
        endamount: form.endamount,
        sortname:form.sortname,
        orderby:form.orderby,
      }).then((res) => {
        if (res.info.length > 0) {
          this.data = res.info;
          this.pager = res.pager;
          this.page = 1;
        } else {
          this.data = [];
          this.pager = [];
        }
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },

    changeordertype () {
      this.getstore();
    },
    changepage (val) {
      this.page = val;
      this.getstore();
    },
    changesize (val) {
      this.pagesize = val;
      this.getstore();
    },

    changestore (store_id) {
      this.store_id = store_id;
      this.getcashlogs();

    },

    gotoruter (name) {
      this.$router.push(name)
    },
    async getstore () {
      this.loading = true;
      this.post('/api/funds/getstore', {
      }).then((res) => {
        if (res.length > 0) {
          this.store_id = res[0].id;
        }
        this.stores = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(async () => {
        await this.getCurrency(); // 獲取貨幣
        this.getcashlogs(); // 獲取記錄
      })


    }

  },
  created () {
    this.getstore();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getcashlogs();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.textred {
  color: red;
}
.textblue {
  color: blue;
}
</style>
